module.exports = __webpack_public_path__ + "img/case13.efc487db.png";